<template>
  <div id="contenedor-tipos-documentos-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'TiposDocumentosMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
